export default "__VITE_ASSET__B2OCisnu__"